import {ShipperCountryCd} from '../';
import {EnumHelper} from './enum-helper';

export class ShipperCountryCdHelperEnumHelperClass extends EnumHelper {

  public constructor() {
  	super();
    for ( const obj in ShipperCountryCd ) {
      this._values.push(ShipperCountryCd[obj]);
      this._keys.push(obj);
    }
  }

  public toEnum(value: string): ShipperCountryCd {

    for ( const obj in ShipperCountryCd ) {
      if (ShipperCountryCd[obj] === value){
        return ShipperCountryCd[obj] as ShipperCountryCd;
      }
    }
  }
}

const ShipperCountryCdHelper = new ShipperCountryCdHelperEnumHelperClass();
export default ShipperCountryCdHelper;
